import React, { useEffect, useRef, useState } from 'react';
import { Box, Typography, Container, Button, Grid, Paper } from '@mui/material';
import PublicRoundedIcon from '@mui/icons-material/PublicRounded';
import { Link } from 'react-router-dom';

const countries = [
  { code: 'IN', name: 'India', flagUrl: 'https://flagcdn.com/in.svg' },
  { code: 'FR', name: 'France', flagUrl: 'https://flagcdn.com/fr.svg' },
  { code: 'US', name: 'USA', flagUrl: 'https://flagcdn.com/us.svg' },
  { code: 'JP', name: 'Japan', flagUrl: 'https://flagcdn.com/jp.svg' },
  { code: 'MA', name: 'Morocco', flagUrl: 'https://flagcdn.com/ma.svg' },
  { code: 'SG', name: 'Singapore', flagUrl: 'https://flagcdn.com/sg.svg' },
];

const ExportTeaser = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const fadeInStyle = {
    opacity: visible ? 1 : 0,
    transform: visible ? 'none' : 'translateY(40px)',
    transition: 'opacity 1s cubic-bezier(.23,1.01,.32,1), transform 1s cubic-bezier(.23,1.01,.32,1)',
  };

  return (
    <Box ref={ref} sx={{ bgcolor: '#f9f9f9', py: { xs: 4, md: 7 }, textAlign: 'center', ...fadeInStyle, px: { xs: 0.5, sm: 0 } }}>
      <Container maxWidth="md" sx={{ px: { xs: 0.5, sm: 0 } }}>
        <PublicRoundedIcon sx={{ fontSize: { xs: 36, sm: 48 }, color: 'primary.main', mb: 1 }} />
        <Typography variant="h4" sx={{ fontWeight: 900, mb: 1, letterSpacing: '0.08em', color: 'primary.main', textTransform: 'uppercase', fontSize: { xs: '1.3rem', sm: '2rem', md: '2.3rem' } }}>
          Our Global Export Reach
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mb: 3, fontSize: { xs: '1rem', sm: '1.1rem' } }}>
          Delivering sustainable timber products across continents
        </Typography>
        <Grid container spacing={2} justifyContent="center" alignItems="flex-end" wrap="wrap" sx={{ mb: 3, flexWrap: { xs: 'nowrap', sm: 'wrap' }, overflowX: { xs: 'auto', sm: 'visible' } }}>
          {countries.map((country) => (
            <Grid item xs={4} sm={2} key={country.code} sx={{ minWidth: 90, flex: { xs: '0 0 auto', sm: '1 1 0%' }, px: { xs: 0.5, sm: 1 } }}>
              <Paper elevation={2} sx={{ p: { xs: 1, sm: 2 }, display: 'flex', flexDirection: 'column', alignItems: 'center', bgcolor: '#fff', borderRadius: 3, minWidth: 70 }}>
                <Box sx={{ mb: 1 }}>
                  <img src={country.flagUrl} alt={country.name + ' flag'} style={{ width: 32, height: 22, borderRadius: 4, boxShadow: '0 2px 8px 0 rgba(0,0,0,0.08)' }} />
                </Box>
                <Typography variant="body2" sx={{ fontWeight: 600, color: 'primary.main', fontSize: { xs: '0.95rem', sm: '1rem' } }}>{country.name}</Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Button
          variant="outlined"
          color="primary"
          size="large"
          component={Link}
          to="/countries"
          sx={{ mt: 3, px: { xs: 3, sm: 4 }, py: { xs: 1, sm: 1.2 }, fontWeight: 700, borderRadius: 2, borderColor: '#8B5E3C', color: '#8B5E3C', background: '#fff', fontSize: { xs: '1rem', sm: '1.1rem' }, minWidth: { xs: 120, sm: 160 }, minHeight: { xs: 40, sm: 48 }, '&:hover': { background: '#8B5E3C', color: '#fff', borderColor: '#8B5E3C' } }}
        >
          View Full Export Map
        </Button>
      </Container>
    </Box>
  );
};

export default ExportTeaser; 